import React, { useContext } from "react"
import { Typography } from "@stardust-ds/react"
import intl from "react-intl-universal"

import styles from "./index.module.scss"
import { useState } from "react"
import FileUploadIcon from "../../../assets/icons/fileUploadIcon"
import { fnFormatDate } from "../../../utils/date"
import AuthContext from "../../../contexts/Auth"
import RcmpFormErrorMessage from "../FormErrorMessage"

const aExtensions = ["doc", "docx", "pdf", "xls", "xlsx", "jpg", "png"]
const aFileTypes = ["image", "video"]

export default function FileInput(props) {
  const { fnFileSubmit, bIsAuthenticated = true, bOtherExtensions, nSizeFile = 10 } = props
  const [bErrorMessage, fnSetBErrorMessage] = useState(false)
  const [bErrorMessageSize, fnSetBErrorMessageSize] = useState(false)

  let oUser = {}

  if (bIsAuthenticated) {
    oUser = useContext(AuthContext).oUser
  }
  const cUserName = bIsAuthenticated ? oUser?.data?.user_cname : ""

  function formatBytes(bytes, decimals = 2) {
    if (!+bytes || bytes > (nSizeFile * 1000000)) {
      fnSetBErrorMessageSize(true)
      return false
    }

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    fnSetBErrorMessageSize(false)
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
  }

  function fnValidateExtension(oFile) {
    const aFileExtension = oFile?.name?.split(".")
    const cFileExtension = aFileExtension[aFileExtension.length - 1]

    if (
      aExtensions.includes(cFileExtension) ||
      aFileTypes.filter((cFieldType) => oFile?.type?.includes(cFieldType))?.length
    ) {
      fnSetBErrorMessage(false)
      return true
    }
    fnSetBErrorMessage(true)
    return false
  }

  function handleDragOver(event) {
    event.preventDefault()
  }

  const uploadHandler = (event) => {
    event.preventDefault()

    const file = event?.target?.files
    file.isUploading = true

    const aFilesToSend = Array.from(file).map((f) => {
      if (formatBytes(f.size) && fnValidateExtension(f)) {
        return {
          opae_cfilename: f.name.split(".").slice(0, -1).join("."),
          opae_cvalue: f,
          opae_ctype: "FILE",
        }
      }
      return false
    })
    aFilesToSend && fnFileSubmit(aFilesToSend)
  }

  function uploadDragAndDrop(event) {
    event.preventDefault()

    const file = event.dataTransfer.files
    file.isUploading = true

    const aFilesToSend = Array.from(file).map((f) => {
      if (formatBytes(f.size) && fnValidateExtension(f)) {
        return {
          opae_cfilename: f.name.split(".").slice(0, -1).join("."),
          opae_cvalue: f,
          opae_ctype: "FILE",
        }
      }
      return false
    })
    aFilesToSend && fnFileSubmit(aFilesToSend)
  }

  function fnHandleOpenInputFile() {
    const elInput = document.querySelector("#input-file")
    if (!elInput) return

    // reset value to allow upload same file
    elInput.value = null
    elInput.click()
  }

  return (
    <div className={styles.fileUploadContainer}>
      <div
        className={styles.fileCard}
        onClick={fnHandleOpenInputFile}
        onDrop={uploadDragAndDrop}
        onDragOver={handleDragOver}
      >
        <div className={styles.fileInput}>
          <input
            id="input-file"
            type="file"
            multiple
            onChange={(e) => uploadHandler(e)}
          />
          <FileUploadIcon />
        </div>
        <div className={styles.LabelInput}>
          <Typography type="h3">
            {bOtherExtensions
              ? intl.get("ActivityEvidence.sent_files_image")
              : intl.get("ActivityEvidence.sent_files")}
          </Typography>
          <Typography type="p3">
            {bOtherExtensions
              ? intl.get("ActivityEvidence.allowed_extensions_format", {
                  extensions: "PNG, JPG e GIF",
                })
              : intl.get("ActivityEvidence.allowed_extensions", {
                  extensions: "PDF, DOC, DOCX, XLS, XLSX, JPG, PNG",
                })}
          </Typography>
          <Typography type="p3">
            {intl.get("ActivityEvidence.file_max_size", { size: `${nSizeFile}mb` })}
          </Typography>
        </div>
      </div>
      {bErrorMessage && (
        <RcmpFormErrorMessage>
          {intl.get("ActivityEvidence.file_extension_error")}
        </RcmpFormErrorMessage>
      )}
      {bErrorMessageSize && (
        <RcmpFormErrorMessage>
          {intl.get("ActivityEvidence.file_size_error", { size: `${nSizeFile}mb` })}
        </RcmpFormErrorMessage>
      )}
    </div>
  )
}
